import { cn } from '@/shared/lib/cn'
import s from './Segmented.module.css'

type SegmentedItem<T extends string> = {
  value: T
  label: string
  count?: number
}

type SegmentedProps<T extends string> = {
  items: SegmentedItem<T>[]
  value: T
  onChange: (value: T) => void
  className?: string
}

export function Segmented<T extends string>({ items, value, onChange, className }: SegmentedProps<T>) {
  return (
    <div className={cn(s.root, className)}>
      {items.map((item) => (
        <button
          key={item.value}
          type="button"
          aria-pressed={item.value === value}
          className={cn(s.item, item.value === value && s.active)}
          onClick={() => onChange(item.value)}
        >
          {item.label}
          {item.count !== undefined && <span className={s.count}>{item.count}</span>}
        </button>
      ))}
    </div>
  )
}
